import $ from 'jquery';
if ($('.frequently-asked-questions').length) {
    $(".frequently-asked-questions .faq-handle.closed").click(function () {
        $(this).parent().parent().find(".faq-summary").fadeIn("slow");
        $(this).fadeOut("slow", function () {
            $(this).parent().find(".faq-handle.open").fadeIn("slow");
        });
        $(this).parent().find(".faq-heading").css("border-bottom", "1px solid #cbcbcb");
    });
    $(".frequently-asked-questions .faq-handle.open").click(function () {
        $(this).parent().parent().find(".faq-summary").fadeOut("slow");
        $(this).fadeOut("slow", function () {
            $(this).parent().find(".faq-handle.closed").fadeIn("slow");
        });
        $(this).parent().find(".faq-heading").css("border-bottom", "initial");
    });
}
